module.exports = __webpack_public_path__ + "img/market-new.27921c04.png";